import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { user, cards, notification } from "../../lib/api/api";

import { HandySvg } from "handy-svg";
import iconAlert from "../../assets/icons/svg-sprite/alerts.svg";
import iconCart from "../../assets/icons/svg-sprite/cart.svg";
import iconGrid from "../../assets/icons/svg-sprite/grid.svg";
import iconLogoMobile from "../../assets/images/elems/logo-mobile-short.svg";
import iconLogoTV from "../../assets/images/elems/logo-tv.svg";
import iconMenuToggle from "../../assets/icons/svg-sprite/menu-toggle.svg";
import iconOK from "../../assets/icons/svg-sprite/odnoklassniki.svg";
import iconPinArrowDown from "../../assets/icons/svg-sprite/pin-arrow-down.svg";
import iconSearch from "../../assets/icons/svg-sprite/search.svg";
import iconThumbUp from "../../assets/icons/svg-sprite/thumb-up.svg";
import iconUser from "../../assets/icons/svg-sprite/user.svg";
import iconVK from "../../assets/icons/svg-sprite/vkontakte.svg";
import iconCallback from "../../assets/images/elems/button_callback_blue.png";

import callbackFormPopup from "../../modules/callback-form-popup";
import initDropdown from "../../modules/init-header-dropdowns";
import initNavigationDropdown from "../../modules/init-navigation-dropdowns";
import initNotificationDropdown from "../../modules/init-notification-dropdowns";
import responsiveHeader from "../../modules/responsive-header";
import stickyHeader from "../../modules/sticky-header";
import supportCallback from "../../modules/support-callback";
import toggleMobileMenu from "../../modules/toggle-mobile-menu";
import anchorScrolling from "../../modules/anchor-scrolling";

const Header = () => {
  const [ID, setID] = useState(0);
  const [name, setName] = useState("");
  const [lastName, setLastName] = useState("");
  const [region, setRegion] = useState("");
  const [notifications, setNotification] = useState([]);

  useEffect(() => {
    callbackFormPopup();
    initDropdown();
    initNavigationDropdown();
    initNotificationDropdown();
    responsiveHeader();
    stickyHeader();
    supportCallback();
    toggleMobileMenu();
    anchorScrolling();
    user
      .userInfo()
      .then((res) => {
        setLastName(res.name_1);
        setName(res.name_2);
      })
      .catch((err) => {
        console.log(err);
      });
    cards
      .userCard()
      .then((res) => {
        setID(res[0].id);
      })
      .catch((err) => {
        console.log(err);
      });
    notification
      .notificationList()
      .then((res) => {
        setNotification(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (ID !== 0) {
      cards
        .card(ID)
        .then((res) => {
          const address = res.address.sort((a, b) =>
            a.type_id < b.type_id ? 1 : -1,
          );
          address.forEach((item) => {
            item.type_id === 3
              ? setRegion(item.value)
              : item.type_id === 2
                ? setRegion(`${item.value} ${item.add}`)
                : item.type_id === 1
                  ? setRegion(`${item.value} ${item.add}`)
                  : setRegion("Не указан");
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [ID]);

  const logout = () => {
    user
      .signOut()
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log("Ошибка: ", err);
      })
      .finally(() => {
        window.location.href = "https://my.telekarta.tv";
      });
  };

  return (
    <>
      <header className="header js-page-header page__header">
        <div className="header__preamble">
          <div className="header__container header__preamble-wrap">
            <div className="header__all-site-wrap js-dropdown-container">
              <button
                className="all-site js-dropdown-initializer header__all-site-btn"
                type="button"
                data-id="all-site"
              >
                <HandySvg
                  className="svg-icon"
                  src={iconGrid}
                  width="13"
                  height="13"
                />
                <span className="all-site__text">Весь сайт</span>
              </button>
              <div className="header__all-site-dropdown js-dropdown-content"></div>
            </div>
            <div className="header__location">
              <section className="location">
                <h6 className="visuallyhidden">
                  Блок c указанием региона и города пользователя
                </h6>
                <span className="location__label">Ваш регион:</span>
                <button className="location__btn" type="btn">
                  <span className="location__btn-text">{region}</span>
                </button>
              </section>
            </div>
            <Link
              className="header__search-btn header__search-btn--grey header__search-btn--desktop"
              to="//telekarta.tv/search/"
            >
              <HandySvg
                className="svg-icon"
                src={iconSearch}
                width="22"
                height="22"
              />
            </Link>
            <div className="header__preamble-right-group">
              <div className="header__quality-offer">
                <button
                  className="quality-offer js-init-callback-form"
                  type="button"
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconThumbUp}
                    width="16"
                    height="16"
                  />
                  <span className="quality-offer__text">
                    Оцените качество обслуживания
                  </span>
                </button>
              </div>
              <div
                className="header__phone-full"
                style={{ marginTop: -9, marginBottom: -9 }}
              >
                <button
                  className="phone-full js-support-callback-trigger"
                  style={{
                    display: "block",
                    position: "relative",
                    fontSize: 15,
                    textAlign: "right",
                  }}
                  type="button"
                >
                  <img src={iconCallback} width="85%" />
                </button>
              </div>
              <div className="header__socials">
                <section className="socials">
                  <h6 className="visuallyhidden">Ссылки на социальные сети</h6>
                  <Link
                    className="socials__link"
                    to="https://vk.com/tvtelekarta"
                    target="_blank"
                  >
                    <span className="visuallyhidden">
                      Ссылка на группу вконтакте
                    </span>
                    <HandySvg
                      className="svg-icon"
                      src={iconVK}
                      width="18"
                      height="18"
                    />
                  </Link>
                  <Link
                    className="socials__link"
                    to="https://ok.ru/telekarta.tv"
                    target="_blank"
                  >
                    <span className="visuallyhidden">
                      Ссылка на группу в одноклассниках
                    </span>
                    <HandySvg
                      className="svg-icon"
                      src={iconOK}
                      width="18"
                      height="18"
                    />
                  </Link>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div className="header__top header__top--grey">
          <div className="header__container header__top-wrap">
            <button
              className="header__menu-btn header__menu-btn--grey js-mobile-menu-opener"
              type="button"
            >
              <HandySvg
                className="svg-icon"
                src={iconMenuToggle}
                width="20"
                height="16"
              />
            </button>
            <Link
              className="header__lk-logo-link header__lk-logo-link--tablet"
              to="/"
            >
              <h1 className="visuallyhidden">Телекарта Онлайн</h1>
              <img
                className="header__logo-tablet"
                src={iconLogoTV}
                width="190"
                height="48"
                alt="Телекарта логотип"
              />
            </Link>
            <button
              className="header__contact-btn header__contact-btn--grey header__contact-btn--mobile bttn js-support-callback-trigger"
              type="button"
              style={{ position: "relative", top: -4 }}
            >
              <img src={iconCallback} width="70%" />
            </button>
            <Link
              to="//telekarta.tv/search/"
              className="header__search-btn header__search-btn--grey header__search-btn--mobile"
            >
              <HandySvg
                className="svg-icon"
                src={iconSearch}
                width="22"
                height="22"
              />
            </Link>
            <div className="header__mobile-profile-label-wrap">
              <button
                className="header__profile-btn header__profile-btn--grey header__profile-btn--mobile js-navigation-dropdown"
                type="button"
              >
                <HandySvg
                  className="svg-icon"
                  src={iconUser}
                  width="20"
                  height="20"
                  style={{ pointerEvents: "none" }}
                />
              </button>
              <div className="header__mobile-profile-label-dropdown header__navigation-dropdown">
                <div className="profile-label-dropdown">
                  <span className="profile-label-dropdown__title title title--h4">
                    Аккаунт
                  </span>
                  <nav className="profile-label-dropdown__navigation">
                    <ul className="profile-label-dropdown__list">
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="//telekarta.tv/subscription_agreement/"
                        >
                          Абонетский договор
                        </Link>
                      </li>
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="/payments"
                        >
                          История платежей
                        </Link>
                      </li>
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="/profile"
                        >
                          Профайл
                        </Link>
                      </li>
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="/password"
                        >
                          Изменить пароль
                        </Link>
                      </li>
                    </ul>
                    <div className="profile-label-dropdown__btn-wrap">
                      <button
                        className="profile-label-dropdown__exit-btn"
                        type="button"
                        onClick={logout}
                      >
                        Выйти
                      </button>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div className="header__right-group">
              <div className="header__desktop-navigation-wrap js-header-desktop-navigation-wrap hidden">
                <ul className="pages-list js-visible-list">
                  <li className="pages-list__item js-visible-item">
                    <a
                      className="pages-list__link js-visible-link js-anchor-link"
                      href="#my-account"
                    >
                      Оплата
                    </a>
                  </li>
                  <li className="pages-list__item js-visible-item">
                    <a
                      className="pages-list__link js-visible-link js-anchor-link"
                      href="#my-actions"
                    >
                      Акции
                    </a>
                  </li>
                  <li className="pages-list__item js-visible-item">
                    <Link
                      className="pages-list__link js-visible-link"
                      to="//shop.telekarta.tv"
                    >
                      Оборудование
                    </Link>
                  </li>
                  <li className="pages-list__item js-visible-item">
                    <Link
                      className="pages-list__link js-visible-link"
                      to="//telekarta.tv/packages/#tariffs"
                    >
                      Все пакеты
                    </Link>
                  </li>
                </ul>
                <div className="pages-list js-dropdown-container pages-list--hidden hidden js-pages-list--hidden">
                  <button
                    className="pages-list__btn js-dropdown-initializer"
                    type="button"
                    data-id="hidden-menu-items"
                  >
                    Ещё
                    <HandySvg
                      className="svg-icon"
                      src={iconPinArrowDown}
                      width="5"
                      height="5"
                    />
                  </button>
                  <div className="js-dropdown-content pages-list__dropdown"></div>
                </div>
              </div>
              <div className="header__notification-wrap">
                <button
                  className="notification-btn header__notification-btn js-notification-dropdown"
                  type="button"
                  data-count={notifications?.unread ?? 0}
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconAlert}
                    width="24"
                    height="24"
                  />
                </button>
                <div className="header__notification-dropdown">
                  <div className="dropdown">
                    <span className="dropdown__title title title--h4">
                      Уведомления
                    </span>
                    <ul className="dropdown__list">
                      {(notifications?.notify ?? []).slice(0, 3).map((item) => {
                        const content = (
                          <div className="dropdown__container">
                            {!item.is_read && (
                              <span className="dropdown__item-circle" />
                            )}

                            {item.title.trim() !== "" && (
                              <span className="dropdown__item-title">
                                {item.title}
                              </span>
                            )}

                            <p className="dropdown__item-description">
                              {item.text}
                            </p>
                          </div>
                        );

                        return (
                          <li className="dropdown__item">
                            {item.url?.trim() ? (
                              <Link className="dropdown__link" to={item.url}>
                                {content}
                              </Link>
                            ) : (
                              <div className="dropdown__link">{content}</div>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                    <div className="dropdown__btn-wrap">
                      <div className="dropdown__container">
                        <Link
                          className="dropdown__more-link solid-btn solid-btn--blue bttn"
                          to="/notifications"
                        >
                          Показать все
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="header__cart-wrap">
                <Link
                  className="cart-btn header__cart-btn"
                  to="//shop.telekarta.tv"
                  data-count="0"
                >
                  <HandySvg
                    className="svg-icon cart-btn__icon"
                    src={iconCart}
                    width="24"
                    height="24"
                  />
                </Link>
              </div>
              <div className="header__profile-label-wrap">
                <button
                  className="profile-label header__profile-label-btn js-navigation-dropdown"
                  type="button"
                  data-label={
                    lastName.trim() !== ""
                      ? lastName.slice(0, 1)
                      : name.trim() !== ""
                        ? name.slice(0, 1)
                        : "А"
                  }
                >
                  <span className="profile-label__name">
                    {name.trim() === "" && lastName.trim() === "" ? (
                      <span className="profile-label__line">Абонент</span>
                    ) : (
                      <>
                        <span className="profile-label__line">{lastName}</span>
                        <span className="profile-label__line">{name}</span>
                      </>
                    )}
                  </span>
                </button>
                <div className="header__profile-label-dropdown header__navigation-dropdown">
                  <div className="profile-label-dropdown">
                    <span className="profile-label-dropdown__title title title--h4">
                      Аккаунт
                    </span>
                    <nav className="profile-label-dropdown__navigation">
                      <ul className="profile-label-dropdown__list">
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="//telekarta.tv/subscription_agreement/"
                          >
                            Абонетский договор
                          </Link>
                        </li>
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="/payments"
                          >
                            История платежей
                          </Link>
                        </li>
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="/profile"
                          >
                            Профайл
                          </Link>
                        </li>
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="/password"
                          >
                            Изменить пароль
                          </Link>
                        </li>
                      </ul>
                      <div className="profile-label-dropdown__btn-wrap">
                        <button
                          className="profile-label-dropdown__exit-btn"
                          type="button"
                          onClick={logout}
                        >
                          Выйти
                        </button>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header__bottom">
          <Link
            className="header__lk-logo-link header__lk-logo-link--mobile"
            to="/"
          >
            <h1 className="visuallyhidden">Телекарта Онлайн</h1>
            <img
              className="header__logo-mobile"
              src={iconLogoMobile}
              width="125"
              height="48"
              alt="Телекарта логотип"
            />
          </Link>
          <div className="header__mobile-notification-wrap">
            <div className="header__notification-wrap">
              <button
                className="notification-btn header__notification-btn js-notification-dropdown"
                type="button"
                data-count={notifications?.unread ?? 0}
              >
                <HandySvg
                  className="svg-icon"
                  src={iconAlert}
                  width="24"
                  height="24"
                />
              </button>
              <div className="header__notification-dropdown">
                <div className="dropdown">
                  <span className="dropdown__title title title--h4">
                    Уведомления
                  </span>
                  <ul className="dropdown__list">
                    {(notifications?.notify ?? []).slice(0, 3).map((item) => {
                      const content = (
                        <div className="dropdown__container">
                          {!item.is_read && (
                            <span className="dropdown__item-circle" />
                          )}

                          {item.title.trim() !== "" && (
                            <span className="dropdown__item-title">
                              {item.title}
                            </span>
                          )}

                          <p className="dropdown__item-description">
                            {item.text}
                          </p>
                        </div>
                      );

                      return (
                        <li className="dropdown__item">
                          {item.url?.trim() ? (
                            <Link className="dropdown__link" to={item.url}>
                              {content}
                            </Link>
                          ) : (
                            <div className="dropdown__link">{content}</div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                  <div className="dropdown__btn-wrap">
                    <div className="dropdown__container">
                      <Link
                        className="dropdown__more-link solid-btn solid-btn--blue bttn"
                        to="/notifications"
                      >
                        Показать все
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="header__cart-wrap">
              <Link
                className="cart-btn header__cart-btn"
                to="//shop.telekarta.tv"
                data-count="0"
              >
                <HandySvg
                  className="svg-icon cart-btn__icon"
                  src={iconCart}
                  width="24"
                  height="24"
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="header__hidden-dropdowns-store">
          <div
            className="profile-label-dropdown js-dropdown"
            id="profile-label"
          >
            <span className="profile-label-dropdown__title title title--h4">
              Аккаунт
            </span>
            <nav className="profile-label-dropdown__navigation">
              <ul className="profile-label-dropdown__list">
                <li className="profile-label-dropdown__item">
                  <Link
                    className="profile-label-dropdown__link"
                    to="//telekarta.tv/subscription_agreement/"
                  >
                    Абонетский договор
                  </Link>
                </li>
                <li className="profile-label-dropdown__item">
                  <button className="profile-label-dropdown__link paymentLink">
                    История платежей
                  </button>
                </li>
                <li className="profile-label-dropdown__item">
                  <button className="profile-label-dropdown__link profileLink">
                    Профайл
                  </button>
                </li>
                <li className="profile-label-dropdown__item">
                  <button className="profile-label-dropdown__link passwordLink">
                    Изменить пароль
                  </button>
                </li>
              </ul>
              <div className="profile-label-dropdown__btn-wrap">
                <button
                  className="profile-label-dropdown__exit-btn"
                  type="button"
                  onClick={logout}
                >
                  Выйти
                </button>
              </div>
            </nav>
          </div>
          <div className="all-site-dropdown js-dropdown" id="all-site">
            <h4 className="visuallyhidden">Ссылки на все разделы сайта</h4>
            <nav className="all-site-dropdown__navigation">
              <ul className="all-site-dropdown__list">
                <li className="all-site-dropdown__item">
                  <Link
                    className="all-site-dropdown__link js-dropdown-link"
                    to="/"
                  >
                    Личный кабинет
                  </Link>
                </li>
                <li className="all-site-dropdown__item">
                  <Link
                    className="all-site-dropdown__link js-dropdown-link"
                    to="//telekarta.tv/payment/"
                  >
                    Оплата
                  </Link>
                </li>
                <li className="all-site-dropdown__item">
                  <Link
                    className="all-site-dropdown__link js-dropdown-link"
                    to="//telekarta.tv/exchange/"
                  >
                    Обмен приемника
                  </Link>
                </li>
                <li className="all-site-dropdown__item">
                  <Link
                    className="all-site-dropdown__link js-dropdown-link"
                    to="//shop.telekarta.tv"
                  >
                    Магазин
                  </Link>
                </li>
                <li className="all-site-dropdown__item">
                  <Link
                    className="all-site-dropdown__link js-dropdown-link"
                    to="//onlinetv.telekarta.tv"
                  >
                    Онлайн-кинотеатр
                  </Link>
                </li>
                <li className="all-site-dropdown__item">
                  <Link
                    className="all-site-dropdown__link js-dropdown-link"
                    to="https://internet.telekarta.tv/"
                  >
                    Интернет
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          <div
            className="hidden-pages-dropdown js-dropdown"
            id="hidden-menu-items"
          >
            <h4 className="visuallyhidden">Ссылки на все разделы сайта</h4>
            <nav className="hidden-pages-dropdown__navigation">
              <ul className="hidden-pages-dropdown__list js-hidden-list"></ul>
            </nav>
          </div>
        </div>
      </header>

      {/* Sticky header exists only on the index page */}
      <header className="sticky-header js-sticky-header">
        <div className="sticky-header__top">
          <div className="sticky-header__container sticky-header__top-wrap">
            <button
              className="sticky-header__menu-btn js-mobile-menu-opener"
              type="button"
            >
              <HandySvg
                className="svg-icon"
                src={iconMenuToggle}
                width="20"
                height="16"
              />
            </button>
            <a
              className="sticky-header__logo-link sticky-header__logo-link--top"
              href="/"
            >
              <img
                className="sticky-header__logo-img"
                src={iconLogoTV}
                width="190"
                height="48"
                alt="Телекарта логотип"
              />
            </a>
            <button
              className="sticky-header__contact-btn bttn js-support-callback-trigger"
              type="button"
            >
              <img src={iconCallback} width="60%" />
            </button>
            <a
              href="//telekarta.tv/search/"
              className="sticky-header__search-btn"
            >
              <HandySvg
                className="svg-icon"
                src={iconSearch}
                width="22"
                height="22"
              />
            </a>
            <div className="sticky-header__mobile-profile-label-wrap">
              <button
                className="sticky-header__profile-btn js-navigation-dropdown"
                type="button"
              >
                <HandySvg
                  className="svg-icon"
                  src={iconUser}
                  width="22"
                  height="20"
                  style={{ pointerEvents: "none" }}
                />
              </button>
              <div className="sticky-header__mobile-profile-label-dropdown header__navigation-dropdown">
                <div className="profile-label-dropdown">
                  <span className="profile-label-dropdown__title title title--h4">
                    Аккаунт
                  </span>
                  <nav className="profile-label-dropdown__navigation">
                    <ul className="profile-label-dropdown__list">
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="//telekarta.tv/subscription_agreement/"
                        >
                          Абонетский договор
                        </Link>
                      </li>
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="/payments"
                        >
                          История платежей
                        </Link>
                      </li>
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="/profile"
                        >
                          Профайл
                        </Link>
                      </li>
                      <li className="profile-label-dropdown__item">
                        <Link
                          className="profile-label-dropdown__link"
                          to="/password"
                        >
                          Изменить пароль
                        </Link>
                      </li>
                    </ul>
                    <div className="profile-label-dropdown__btn-wrap">
                      <button
                        className="profile-label-dropdown__exit-btn"
                        type="button"
                        onClick={logout}
                      >
                        Выйти
                      </button>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
            <div className="sticky-header__right-group">
              <div className="sticky-header__notification-wrap">
                <button
                  className="notification-btn sticky-header__notification-btn js-notification-dropdown"
                  type="button"
                  data-count={notifications?.unread ?? 0}
                >
                  <HandySvg
                    className="svg-icon"
                    src={iconAlert}
                    width="24"
                    height="24"
                  />
                </button>
                <div className="sticky-header__notification-dropdown">
                  <div className="dropdown">
                    <span className="dropdown__title title title--h4">
                      Уведомления
                    </span>
                    <ul className="dropdown__list">
                      {(notifications?.notify ?? []).slice(0, 3).map((item) => {
                        const content = (
                          <div className="dropdown__container">
                            {!item.is_read && (
                              <span className="dropdown__item-circle" />
                            )}

                            {item.title.trim() !== "" && (
                              <span className="dropdown__item-title">
                                {item.title}
                              </span>
                            )}

                            <p className="dropdown__item-description">
                              {item.text}
                            </p>
                          </div>
                        );

                        return (
                          <li className="dropdown__item">
                            {item.url?.trim() ? (
                              <Link className="dropdown__link" to={item.url}>
                                {content}
                              </Link>
                            ) : (
                              <div className="dropdown__link">{content}</div>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                    <div className="dropdown__btn-wrap">
                      <div className="dropdown__container">
                        <Link
                          className="dropdown__more-link solid-btn solid-btn--blue bttn"
                          to="/notifications"
                        >
                          Показать все
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="sticky-header__cart-wrap">
                <a
                  className="cart-btn sticky-header__cart-btn"
                  href="//shop.telekarta.tv"
                  data-count="0"
                >
                  <HandySvg
                    className="svg-icon cart-btn__icon"
                    src={iconCart}
                    width="24"
                    height="24"
                  />
                </a>
              </div>
              <div className="sticky-header__profile-label-wrap">
                <button
                  className="profile-label sticky-header__profile-label-btn js-navigation-dropdown"
                  type="button"
                  data-label={
                    lastName.trim() !== ""
                      ? lastName.slice(0, 1)
                      : name.trim() !== ""
                        ? name.slice(0, 1)
                        : "А"
                  }
                >
                  <span className="profile-label__name">
                    {name.trim() === "" && lastName.trim() === "" ? (
                      <span className="profile-label__line">Абонент</span>
                    ) : (
                      <>
                        <span className="profile-label__line">{lastName}</span>
                        <span className="profile-label__line">{name}</span>
                      </>
                    )}
                  </span>
                </button>
                <div className="sticky-header__profile-label-dropdown header__navigation-dropdown">
                  <div className="profile-label-dropdown">
                    <span className="profile-label-dropdown__title title title--h4">
                      Аккаунт
                    </span>
                    <nav className="profile-label-dropdown__navigation">
                      <ul className="profile-label-dropdown__list">
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="//telekarta.tv/subscription_agreement/"
                          >
                            Абонетский договор
                          </Link>
                        </li>
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="/payments"
                          >
                            История платежей
                          </Link>
                        </li>
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="/profile"
                          >
                            Профайл
                          </Link>
                        </li>
                        <li className="profile-label-dropdown__item">
                          <Link
                            className="profile-label-dropdown__link"
                            to="/password"
                          >
                            Изменить пароль
                          </Link>
                        </li>
                      </ul>
                      <div className="profile-label-dropdown__btn-wrap">
                        <button
                          className="profile-label-dropdown__exit-btn"
                          type="button"
                          onClick={logout}
                        >
                          Выйти
                        </button>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sticky-header__bottom">
          <div className="sticky-header__bottom-inner">
            <a
              className="sticky-header__logo-link sticky-header__logo-link--bottom"
              href="/"
            >
              <img
                className="sticky-header__logo-img"
                src={iconLogoMobile}
                width="84"
                height="32"
                alt="Телекарта логотип"
              />
            </a>
            <ul className="sticky-header__fast-links js-sticky-header-fast-links">
              <li className="sticky-header__fast-links-item">
                <a
                  className="sticky-header__fast-link js-sticky-header-fast-link"
                  href="#fillup-account"
                >
                  <span className="sticky-header__fast-link-text">
                    Пополнить счёт
                  </span>
                </a>
              </li>
              <li className="sticky-header__fast-links-item">
                <a
                  className="sticky-header__fast-link js-sticky-header-fast-link"
                  href="#main-tariff"
                >
                  <span className="sticky-header__fast-link-text">
                    Управление подпиской
                  </span>
                </a>
              </li>
              <li className="sticky-header__fast-links-item">
                <a
                  className="sticky-header__fast-link js-sticky-header-fast-link"
                  href="#tv-program"
                >
                  <span className="sticky-header__fast-link-text">
                    Программа передач
                  </span>
                </a>
              </li>
              <li className="sticky-header__fast-links-item">
                <a
                  className="sticky-header__fast-link js-sticky-header-fast-link"
                  href="#news"
                >
                  <span className="sticky-header__fast-link-text">Новости</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
